import React, { useEffect, useState } from 'react';

import 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react'; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme

import AgGridService from '../../../shared/services/ag-grid/ag-grid.service';

import IException from '../../../shared/contracts/IException';
import useLoader from '../../../shared/components/loading-dialog/useLoader.hook';
import LoadingDialogComponent from '../../../shared/components/loading-dialog/loading-dialog.component';
import { GridReadyEvent } from 'ag-grid-community';
import ITaskImport from '../../../shared/contracts/ITaskImport';
import useRMSCoreApi from './useRMSCoreApi';
import TaskImportService from './task-import.service';
import TaskImportToolbarComponent from './components/task-import-toolbar.component';
import useAppStoreContext from '../../../shared/context/app-store/app-store.context';

interface IProps {

}
function TaskImportPage({ }: IProps) {

  // ---
  const { getTaskImportList } = useRMSCoreApi();
  const { taskImportList, setTaskImportList } = useAppStoreContext();
  const [showCreateReportsDialog, setShowCreateReportsDialog] = useState<boolean>(false);
  const [isReloadData, setIsReloadData] = useState<boolean>(false);
  const { getDefaultColDef, getDefaultProps } = new AgGridService();

  const taskImportListLoader = useLoader({
    loaderName: 'Task Import List',
    loadAsync: () => getTaskImportList({
      doIf: () => taskImportListLoader.isNotLoading,
      doBefore: () => {
        taskImportListLoader.SET_LOADING('Fetching...');
        setTaskImportList([]);
      },
      onFulfilled: (data) => {
        setTaskImportList(data);
        taskImportListLoader.SET_SUCCESS('Fetch Success.!');
      },
      onException: (exception: IException) => {
        taskImportListLoader.SET_FAILURE(exception.title + ' - ' + exception.message);
      }
    })
  });

  useEffect(() => {
    taskImportListLoader.loadAsync();
  }, [isReloadData]);


  const handleGridReady = (e: GridReadyEvent<ITaskImport>) => {
    e.api.autoSizeAllColumns();
  }

  return (<>

    {/* Loading dialog */}
    <LoadingDialogComponent loaderHook={taskImportListLoader} />

    {/* Toolbar */}
    <TaskImportToolbarComponent onReload={taskImportListLoader.loadAsync} handleCreateReportClick={() => { setShowCreateReportsDialog(true) }} />

    {/* Create Report dialog */}
    {/* {showCreateReportsDialog && <CreateReportDialogComponent open={showCreateReportsDialog}
      onClose={() => { setShowCreateReportsDialog(false) }}
      onApply={() => {
        setShowCreateReportsDialog(false);
        setIsReloadData(true);
      }} />} */}

    {/* The AG Grid component */}
    <div className={'ag-theme-quartz'} style={{ height: `calc(100vh - ${108}px)` }} >

      <AgGridReact {...getDefaultProps({})}
        onGridReady={handleGridReady}
        defaultColDef={{ ...getDefaultColDef() }}
        columnDefs={TaskImportService.colDefs}
        rowData={taskImportList || []}
      />

    </div>

  </>);
}
export default TaskImportPage;